import React, { useState, useEffect, useRef } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Slider, FormControl, Select, MenuItem, TextField, InputAdornment } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
    wrapper: props => ({
        width: '100%',
        borderBottom: '1px solid #dee2f0',
        height: props.pageType === 1 ? '480px' : props.pageType === 2 || props.pageType === 5 ? '340px' : '220px'
    }),

    label: props => ({
        color: props.config.misc.color, //'rgb(0,0,160)',
        fontSize: '18px',
        fontWeight: '400'
    }),
    sliderBox: {
        paddingTop: "32px",
        height: "52px",
        margin: '0 32px'
    },
    listBox: {
        paddingTop: "32px",
        height: "72px",
        margin: '0 32px'
    },
    sliderBoxInner: {
        display: 'flex'
    },
    sliderBoxRight: {
        marginLeft: 'auto',
        order: 2
    },
    formControl: props => ({
        width: '100%',
        borderBottom: `1px solid ${props.config.misc.color}`, //'rgb(0,0,160)',

    }),
    selectBox: props => ({
        color: props.config.misc.color, //'rgb(0,0,160)',
    })
}));

const silderStyles = makeStyles({
    // style rule
    main: props => ({
        color: props.color,
    }),

});

const PaymentTerms = props => {
    //const Slider = getSlider({color:props.config.misc.color, backgroundColor:props.config.misc.backgroundColor});
    const sliderClasses = silderStyles({ color: props.config.misc.color });
    const classes = useStyles(props);
    const [maxAmountWarning, setmaxAmountWarning] = useState(false);
    const [maxAmountPartPayment, setMaxAmountPartPayment] = useState(0);

    const [minAmountWarning, setMinAmountWarning] = useState(false);
    const [minAmountPartPayment, setMinAmountPartPayment] = useState(0);

    const [previousOption, setPreviousOption] = useState(0);

    const priceInput = useRef();

    const config = props.config;

    const getMaxYears = () => {
        if (props.objectType === '') {
            return props.pageType === 3 ? Number(config.sliders.years.max) : 15;
        }

        let currentObjectType = config.lists.objectType.filter(item => item.id === props.objectType);

        if (currentObjectType.length === 0) {

            if (config.sliders && config.sliders.years && config.sliders.years.max) {
                return Number(config.sliders.years.max);
            }
            return 15;
        }

        return Number(currentObjectType[0].maxYears);
    }

    const handleAmountChange = event => {
        let { value, min, max } = event.target;

        if (!Number(value)) {
            return false;
        }

        if (Number(value) > maxAmountPartPayment) {
            setmaxAmountWarning(true);
        } else {
            setmaxAmountWarning(false);
        }

        if (Number(value) < minAmountPartPayment) {
            setMinAmountWarning(true);
        } else {
            setMinAmountWarning(false);
        }

        if (Number(value) < minAmountPartPayment) {
            props.setPrice(value)
        } else {
            value = Math.max(Number(min), Math.min(Number(max), Number(value)));
            props.setPrice(value)
        }

    };

    useEffect(() => {
        if (maxAmountPartPayment === 0 && props.pageType === 4) {
            setMaxAmountPartPayment(Number(config.lists.partPaymentOptions[0].maxAmount))
        }

        if (minAmountPartPayment === 0 && props.pageType === 4) {
            setMinAmountPartPayment(Number(config.lists.partPaymentOptions[0].minAmount))
        }

        /*if(props.price === minAmountPartPayment) {
            priceInput.current.type = 'text';
            priceInput.current.selectionStart = 0;
            priceInput.current.selectionEnd = 0;
            priceInput.current.type = 'number';
            
        }*/

        //maybe
        /*if(props.price === maxAmountPartPayment) {
            priceInput.current.selectionStart = 0;
            priceInput.current.selectionEnd = 0; 
        }*/

    }, [maxAmountPartPayment, minAmountPartPayment, props.pageType, config.lists.partPaymentOptions, props.price])


    return (<div className={classes.wrapper}>

        {config.label.objectType && (
            <div className={classes.listBox}>
                <div className={classes.sliderBoxInner}>
                    <div>
                        <div className="nordea-slider" style={{ color: props.config.misc.color }}>{config.label.objectType}</div>
                    </div>
                </div>

                <FormControl className={classes.formControl}>
                    <Select
                        value={props.objectType}
                        onChange={(event) => {
                            let selectedValue = 0;
                            const selectedOption = parseFloat(event.target.value)

                            if (selectedOption !== 0) {
                                const selectedObject = config.lists.objectType.filter(item => item.id === selectedOption);
                                selectedValue = Number(selectedObject[0].intrest);
                            }

                            const newRate = props.intrest - previousOption + selectedValue;
                            props.setIntrest(newRate);
                            props.setObjectType(selectedOption);
                            setPreviousOption(selectedValue);

                        }}
                        displayEmpty
                        className={classes.selectBox}
                        classes={{ icon: classes.selectBox }}
                        disableUnderline={true}
                        inputProps={{ 'aria-label': 'Objekt typ', }}
                    >
                        <MenuItem value="0">Välj…</MenuItem>
                        {config.lists.objectType.map(item => {
                            return <MenuItem key={item.id} value={item.id}>{item.label}</MenuItem>
                        })}
                    </Select>
                </FormControl>
            </div>)}

        <div className={classes.sliderBox}>
            <div className={classes.sliderBoxInner}>
                <div>
                    <div className="nordea-slider" style={{ color: props.config.misc.color }}>{config.label.price}</div>
                </div>
                <div className={classes.sliderBoxRight} style={props.pageType === 4 ? { marginLeft: '130px' } : {}}>
                    <div className="nordea-slider" style={{ color: props.config.misc.color }}>


                        {props.pageType === 4 ? (
                            <FormControl>
                                <TextField

                                    inputRef={priceInput}
                                    InputProps={{
                                        endAdornment: <InputAdornment position="end">kr</InputAdornment>,
                                        inputProps: {
                                            type: 'number',
                                            min: String(minAmountPartPayment),
                                            max: String(maxAmountPartPayment)
                                        },
                                    }} value={props.price} type="currency" size="small" variant="outlined" onChange={e => {
                                        handleAmountChange(e);

                                    }}></TextField>



                            </FormControl>) : Number(props.price).toLocaleString("sv-SE", props.sekFormat).replace(',00', '')}

                    </div>
                </div>
            </div>
            {props.pageType !== 4 && props.config.misc.visibility.price === 2 &&
                <Slider className={`${sliderClasses.main}`} value={props.price} min={Number(config.sliders.price.min)} max={Number(config.sliders.price.max)} step={Number(config.sliders.price.step)}
                    onChange={(e, val) => {
                        props.setPrice(val);
                        props.setDownPayment(val * 0.2)

                    }}></Slider>}
            {maxAmountWarning && <div style={{ color: 'red' }}>Maxbelopp för delbetalningsalternativet är {maxAmountPartPayment} kronor.</div>}
            {minAmountWarning && <div style={{ color: 'red' }}>Minibelopp för delbetalningsalternativet är {minAmountPartPayment} kronor.</div>}
        </div>


        {config.label.downPayment && !!props.config.misc.visibility.downPayment && (
            <div className={classes.sliderBox}>
                <div className={classes.sliderBoxInner}>
                    <div>
                        <div className="nordea-slider" style={{ color: props.config.misc.color }}>{config.label.downPayment}</div>
                    </div>
                    <div className={classes.sliderBoxRight}>
                        <div className="nordea-slider" style={{ color: props.config.misc.color }}>{Number(props.downPayment).toLocaleString("sv-SE", props.sekFormat).replace(',00', '')}</div>
                    </div>
                </div>
                {props.config.misc.visibility.downPayment === 2 && <Slider className={`${sliderClasses.main}`} value={Number(props.downPayment)} min={Number(props.price) * 0.20} max={props.price} step={Number(config.sliders.downPayment.step)} onChange={(e, val) => {
                    props.setDownPayment(val);
                }}></Slider>}
            </div>
        )}

        {config.label.amount && (
            <div className={classes.sliderBox} style={{ marginBottom: '20px' }}>
                <div className={classes.sliderBoxInner}>
                    <div>
                        <div className="nordea-slider" style={{ color: props.config.misc.color }}>{config.label.amount} </div>
                    </div>
                </div>
                <div>
                    <span className="nordea-large" style={{ color: props.config.misc.color }}>
                        {Number(props.amount).toLocaleString("sv-SE", props.sekFormat).replace(',00', '')}</span>
                </div>
            </div>)}

        {config.label.partPayment && props.partPayment !== 0 && (
            <div className={classes.listBox} style={maxAmountWarning || minAmountWarning ? { marginTop: '10px' } : {}}>

                <div className={classes.sliderBoxInner}>
                    <div>
                        <div className="nordea-slider" style={{ color: props.config.misc.color }}>{config.label.partPayment}</div>
                    </div>
                </div>

                <FormControl className={classes.formControl}>
                    <Select
                        value={props.partPayment}
                        onChange={e => {
                            props.setPartPayment(e.target.value);

                            const selectPartPaymentOption = config.lists.partPaymentOptions.find(item => item.id === e.target.value);
                            setMaxAmountPartPayment(Number(selectPartPaymentOption.maxAmount));
                            setMinAmountPartPayment(Number(selectPartPaymentOption.minAmount))

                            if (Number(props.price) > Number(selectPartPaymentOption.maxAmount)) {
                                props.setPrice(Number(selectPartPaymentOption.maxAmount));
                                setmaxAmountWarning(true);
                            } else {
                                setmaxAmountWarning(false);
                            }

                            if (Number(props.price) < Number(selectPartPaymentOption.minAmount)) {
                                props.setPrice(Number(selectPartPaymentOption.minAmount));
                                setMinAmountWarning(true);
                            } else {
                                setMinAmountWarning(false);
                            }

                            props.setIntrest(Number(selectPartPaymentOption.intrest))
                            props.setYears(Number(selectPartPaymentOption.month))
                            props.setToc(selectPartPaymentOption.terms);
                            props.setBuyNow(selectPartPaymentOption.buyNow);
                            props.setConfig({
                                ...props.config,
                                misc: {
                                    ...props.config.misc,
                                    initialFee: selectPartPaymentOption.initialFee,
                                    invoiceFee: selectPartPaymentOption.invoiceFee
                                }
                            })
                        }}
                        displayEmpty
                        className={classes.selectBox}
                        classes={{ icon: classes.selectBox }}
                        disableUnderline={true}
                        inputProps={{ 'aria-label': 'Kundprogram', }}
                    >
                        {config.lists.partPaymentOptions.map((item, index) => {
                            return <MenuItem key={item.id + index} value={item.id}>{item.title}</MenuItem>
                        })}
                    </Select>
                </FormControl>
            </div>
        )}
        {config.label.customerProgram && (
            <div className={classes.listBox}>

                <div className={classes.sliderBoxInner}>
                    <div>
                        <div className="nordea-slider" style={{ color: props.config.misc.color }}>{config.label.customerProgram}</div>
                    </div>
                </div>
                <FormControl className={classes.formControl}>
                    <Select
                        value={props.customerProgram}
                        onChange={e => {
                            props.setCustomerProgram(e.target.value)

                            let selectedIntrest = config.lists.customerProgram.filter(item => item.id === e.target.value);
                            let newIntrest = (selectedIntrest.length && selectedIntrest[0].intrest) ? selectedIntrest[0].intrest : config.misc.defaultIntrest;

                            props.setIntrest(Number(newIntrest))
                            let selectedObject = config.lists.objectType.filter(item => item.id === props.objectType);

                            if (!!selectedObject.length && Number(selectedObject[0].intrest) !== 0) {

                                if (Number(selectedObject[0].intrest) > 0) {

                                    props.setIntrest(Number(newIntrest) + Number(selectedObject[0].intrest))
                                } else {
                                    props.setIntrest(Number(newIntrest) - Math.abs(Number(selectedObject[0].intrest)))
                                }
                            }
                        }}
                        displayEmpty
                        className={classes.selectBox}
                        classes={{ icon: classes.selectBox }}
                        disableUnderline={true}
                        inputProps={{ 'aria-label': 'Kundprogram', }}
                    >
                        <MenuItem value="" >Välj…</MenuItem>
                        {config.lists.customerProgram.map(item => {
                            return <MenuItem key={item.id} value={item.id}>{item.label}</MenuItem>
                        })}
                    </Select>
                </FormControl>
            </div>)}
        {props.pageType !== 4 && !!props.config.misc.visibility.years && (<div className={classes.sliderBox}>
            <div className={classes.sliderBoxInner}>
                <div>
                    <div className="nordea-slider" style={{ color: props.config.misc.color }}>{config.label.years}</div>
                </div>
                <div className={classes.sliderBoxRight}>
                    <div className="nordea-slider" style={{ color: props.config.misc.color }}>{props.years} {props.pageType !== 3 ? ('(max ' + getMaxYears() + ' år)') : ' år'}</div>
                </div>
            </div>
            {props.config.misc.visibility.years === 2 && <Slider className={`${sliderClasses.main}`} value={props.years} min={Number(config.sliders.years.min)} max={getMaxYears()} step={config.sliders.years.step ? Number(config.sliders.years.step) : 1} onChange={(e, val) => { props.setYears(val); }}></Slider>}
        </div>)}
        {props.pageType !== 4 && !!props.config.misc.visibility.intrest && (<div className={classes.sliderBox}>
            <div className={classes.sliderBoxInner}>
                <div>
                    <div className="nordea-slider" style={{ color: props.config.misc.color }}>{config.label.intrest}</div>
                </div>
                <div className={classes.sliderBoxRight}>
                    <div className="nordea-slider" style={{ color: props.config.misc.color }}>{props.intrest.toFixed(2).toString().replace('.', ',')}%</div>
                </div>
            </div>
            {props.pageType !== 4 && props.config.misc.visibility.intrest === 2 && (<Slider className={`${sliderClasses.main}`} value={Number(props.intrest)} min={Number(config.sliders.intrest.min)} max={Number(config.sliders.intrest.max)} step={Number(config.sliders.intrest.step)} onChange={(e, val) => {
                props.setIntrest(val);
            }}></Slider>)}
        </div>)}
    </div>)
}

export default PaymentTerms; 